export default "__VITE_ASSET__d3d85dad__"